import React from "react";
import { Modal, StyleSheet, View, Pressable } from "react-native";
import {
  NormalText,
  PrimaryButton,
  SecondaryButton,
  TitleText,
} from "../../../common/native";
import { useNavigate } from "react-router-dom";

type AnalyticsAccessGateModalProps = {
  isWidgetDeployed: boolean;
};

const AnalyticsAccessGateModal: React.FC<AnalyticsAccessGateModalProps> = ({
  isWidgetDeployed,
}) => {
  const navigate = useNavigate();

  return (
    <Modal animationType="fade" transparent={true} visible={true}>
      <View style={styles.backdrop}>
        <View style={styles.container}>
          <TitleText text="Analytics Access" style={styles.header} />
          {isWidgetDeployed ? (
            <>
              <NormalText
                text="Upgrade your account to view website and form analytics."
                style={styles.body}
              />
              <PrimaryButton
                text="Upgrade Account"
                fullWidth
                onPress={() => navigate("/upgrade")}
              />
              <View style={{ height: 16 }} />
              <SecondaryButton
                text="Maybe Later"
                fullWidth
                onPress={() => navigate("/")}
              />
            </>
          ) : (
            <>
              <NormalText
                text="Deploy your lead conversion widget on your website. Once you do, you can view lead conversion analytics."
                style={styles.body}
              />
              <SecondaryButton
                text="Deploy Lead Conversion Widget"
                fullWidth
                style={styles.deployButton}
                textStyle={styles.deployButtonText}
                onPress={() => navigate("/deploy-widget")}
              />
            </>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  container: {
    width: "100%",
    maxWidth: 520,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 24,
    alignItems: "center",
  },
  header: {
    textAlign: "center",
    marginBottom: 12,
  },
  body: {
    textAlign: "center",
    color: "#1D252D",
    marginBottom: 16,
  },
  inlineLink: {
    color: "#00B7F4",
    textDecorationLine: "underline",
    marginBottom: 16,
  },
  primaryButton: {
    width: "100%",
  },
  deployButton: {
    backgroundColor: "#A1E3CB",
    borderColor: "#A1E3CB",
  },
  deployButtonText: {
    color: "#000000",
  },
});

export default AnalyticsAccessGateModal;
